import baseApi from '@store/api/baseApi';

export const orderDetailsApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		setPoAutmation: builder.mutation({
			query: ({ requestBody }) => {
				return {
					url: '/order/initiate-po-upload',
					method: 'POST',
					body: requestBody
				};
			}
		}),
		setExtractPo: builder.mutation({
			query: ({ requestBody }) => ({
				url: '/order/extract-po',
				method: 'POST',
				body: requestBody
			})
		}),
		setExtractPoDocuments: builder.mutation({
			query: ({ requestBody }) => ({
				url: '/order/place-order-from-po-extraction',
				method: 'POST',
				body: requestBody
			})
		}),
		getCollections: builder.query({
			query: ({ collectionId }) => ({
				url: `/collection/products/${collectionId}?page=0&size=1000&sort=id,asc`,
				method: 'POST',
				body: {
					collectionId,
					isDrafted: false
				}
			})
		}),
		getFolderCollections: builder.query({
			query: ({ folderId }) => ({
				url: `/product/my-favourites?page=0&size=1000&sort=id,asc`,
				method: 'POST',
				body: {
					folderId,
					isDrafted: false,
					isListView: false,
					sortingOption: 'NEWEST',
					search: ''
				}
			})
		}),
		addAiPoExtraction: builder.mutation({
			query: ({ requestBody, orderId }) => ({
				url: `/order/${orderId}/add-styles-from-po-extraction`,
				method: 'POST',
				body: requestBody
			})
		})
	})
});
export const {
	useSetPoAutmationMutation,
	useSetExtractPoMutation,
	useSetExtractPoDocumentsMutation,
	useGetCollectionsQuery,
	useGetFolderCollectionsQuery,
	useAddAiPoExtractionMutation
} = orderDetailsApi;
